module.exports = __webpack_public_path__ + "static/img/logo-woocommerce.a26e140.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-woocommerce.png
// module id = 1zjr
// module chunks = 1